export const PAGE_HEADER_TEST_ID = 'page-header';
export const PAGE_HEADER_TITLE_TEST_ID = 'page-header-title';
export const PAGE_HEADER_CAPTION_TEST_ID = 'page-header-caption';
export const PAGE_HEADER_BACK_BTN_TEST_ID = 'page-header-back-btn';
